<div class="container-fluid">
  <ng-container *ngIf="!fichaBloqueada; else fichaBloqueadaTpl">
    <div class="faixa-somente-leitura" role="status" *ngIf="somenteLeitura">
      <mat-icon class="faixa-icone">lock</mat-icon>
      <span>
        <strong>{{ motivoSomenteLeitura }}.</strong>
        {{ complementoSomenteLeitura }}
      </span>
    </div>
    <div
      class="d-flex justify-content-between"
      style="overflow: hidden"
    >

      <div
        class="container-ficha"
        [class.scroll-ativo]="activeFichaIndex === 1"
        (mouseenter)="activeFichaIndex = 1"
        (mouseleave)="activeFichaIndex = null"
      >
        <div
          class="d-flex justify-content-between align-items-center detalhes-obra"
        >
        <div class="home">
            <button class="btn btn-icon" (click)="voltarParaBusca()">
              <mat-icon class="ficha-icon">home</mat-icon>
            </button>
            <h3>FICHA DA OBRA</h3>
          </div>
          <div>
            <button
              class="btn btn-icon me-1 arrow-icon-btn"
              type="button"
              (click)="voltarObra()"
              [disabled]="!podeVoltar"
              [title]="podeVoltar ? 'Obra anterior' : 'Não há obra anterior'"
            >
              <mat-icon class="ficha-icon">arrow_back</mat-icon>
            </button>

            <button
              class="btn btn-icon arrow-icon-btn"
              type="button"
              (click)="avancar()"
              [disabled]="!podeAvancar"
              [title]="podeAvancar ? 'Próxima obra' : 'Não há próxima obra'"
            >
              <mat-icon class="ficha-icon">arrow_forward</mat-icon>
            </button>
          </div>
        </div>
        <app-detalhe-da-obra
          [idObra]="idObra"
          [moduloId]="moduloId"
          [contextoResultado]="contextoResultado"
          (loadingObra)="onLoadingObra($event)"
          (moduleIdLoaded)="onModuleIdLoaded($event)"
          (obraNameLoaded)="onObraNameLoaded($event)"
          (fichaBloqueada)="onFichaBloqueada($event)"
        ></app-detalhe-da-obra>
      </div>

      <div
        class="container-ficha"
        [class.scroll-ativo]="activeFichaIndex === 2"
        (mouseenter)="activeFichaIndex = 2"
        (mouseleave)="activeFichaIndex = null"
      >
        <div class="d-flex justify-content-between align-items-center contatos">
          <h3>
            <mat-icon class="ficha-icon">contacts</mat-icon>
            Contatos
          </h3>
        </div>

        <app-contatos
        [idObra]="idObra"
        [idModulo]="moduloId"
        [somenteLeitura]="somenteLeitura"
        [workName]="obraName"
        [moduleName]="getModuleName(moduloId)"
        [companyId]="companyId"
        [companyName]="companyName"
        (loading)="onPainelLoading($event)"
      ></app-contatos>
      </div>

      <div
        class="container-ficha"
        [class.scroll-ativo]="activeFichaIndex === 3"
        (mouseenter)="activeFichaIndex = 3"
        (mouseleave)="activeFichaIndex = null"
      >
        <div
          class="d-flex justify-content-between align-items-center tarefas-relatos"
        >
          <h3>Tarefas e Relatos</h3>

          <div class="btn-tarefa">
              <button
            class="btn me-1 arrow-icon-btn"
            [title]="somenteLeitura ? dicaSomenteLeitura : 'Adicionar Tarefa'"
            [disabled]="somenteLeitura"
            (click)="openPanel('agendar-tarefa')"
            type="button"
          >
            <mat-icon class="ficha-icon">add_task</mat-icon>
          </button>

          <button
            class="btn arrow-icon-btn"
            [title]="somenteLeitura ? dicaSomenteLeitura : 'Novo Relato'"
            [disabled]="somenteLeitura"
            (click)="openPanel('novo-relato')"
            type="button"
          >
            <mat-icon class="ficha-icon">description</mat-icon>
          </button>
          </div>

        </div>
        <app-tarefas-relatos
          [idObra]="idObra"
          [somenteLeitura]="somenteLeitura"
          (editar)="openPanel('editar-tarefa', $event)"
          (editarRelato)="openPanel('editar-relato', $event)"
          (concluir)="openPanel('conclusao-tarefa', $event)"
          (abrirDescarteTarefa)="abrirPainelDescarteTarefa($event)"
          (abrirDescarteRelato)="abrirPainelDescarteRelato($event)"
        ></app-tarefas-relatos>
      </div>
    </div>
  </ng-container>


  <ng-template #fichaBloqueadaTpl>
    <div class="container-ficha" style="width: 100%; max-width: 100%">
      <div
        class="d-flex justify-content-between align-items-center detalhes-obra"
      >
        <div class="home">
          <button class="btn btn-icon" (click)="voltarParaBusca()">
            <mat-icon class="ficha-icon">home</mat-icon>
          </button>
          <h3>FICHA DA OBRA</h3>
        </div>
        <div>
          <button
            class="btn btn-icon me-1 arrow-icon-btn"
            type="button"
            (click)="voltarObra()"
            [disabled]="!podeVoltar"
            [title]="podeVoltar ? 'Obra anterior' : 'Não há obra anterior'"
          >
            <mat-icon class="ficha-icon">arrow_back</mat-icon>
          </button>

          <button
            class="btn btn-icon arrow-icon-btn"
            type="button"
            (click)="avancar()"
            [disabled]="!podeAvancar"
            [title]="podeAvancar ? 'Próxima obra' : 'Não há próxima obra'"
          >
            <mat-icon class="ficha-icon">arrow_forward</mat-icon>
          </button>
        </div>
      </div>

      <app-ficha-bloqueada [moduloId]="moduloBloqueadoId"></app-ficha-bloqueada>
    </div>
  </ng-template>
</div>

<app-side-panel
  [isOpen]="isPanelOpen"
  [title]="panelTitle"
  (close)="closePanel()"
>
  <ng-container *ngIf="currentPanel === 'novo-relato'">
    <app-novo-relato
      (close)="closePanel()"
      [idObra]="idObra"
      [moduloId]="moduloId"
      (relatoCriado)="onRelatoCriado()"
      (loading)="onPainelLoading($event)"
    ></app-novo-relato>
  </ng-container>
  <ng-container *ngIf="currentPanel === 'agendar-tarefa'">
    <app-agendar-tarefa
      [idObra]="idObra"
      [moduloId]="moduloId"
      (close)="closePanel()"
      (tarefaCriada)="onTarefaCriada()"
      (loading)="onPainelLoading($event)"
    ></app-agendar-tarefa>
  </ng-container>
  <ng-container *ngIf="currentPanel === 'editar-tarefa'">
    <app-editar-tarefa
      [tarefa]="tarefaSelecionada"
      (close)="closePanel()"
      [idObra]="idObra"
      [idModulo]="moduloId"
      (tarefaEditada)="onTarefaEditada()"
      (loading)="onPainelLoading($event)"
    ></app-editar-tarefa>
  </ng-container>
  <ng-container *ngIf="currentPanel === 'conclusao-tarefa'">
    <app-conclusao-tarefa (close)="closePanel()"></app-conclusao-tarefa>
  </ng-container>
  <ng-container *ngIf="currentPanel === 'editar-relato'">
    <app-editar-relato
      [relato]="tarefaSelecionada"
      (close)="closePanel()"
      [idObra]="idObra"
      [moduloId]="moduloId"
      (loading)="onPainelLoading($event)"
      (relatoEditado)="onRelatoEditado()"
    ></app-editar-relato>
  </ng-container>

  <ng-container *ngIf="currentPanel === 'descarte-tarefa'">
    <app-descarte-tarefa
      [idObra]="idObra"
      [tarefa]="tarefaParaDescarte"
      (close)="closePanel()"
      (tarefaDescartada)="fecharDescarteTarefa(true)"
      class="descarte-modal"
      (loading)="onPainelLoading($event)"
    ></app-descarte-tarefa>
  </ng-container>

  <ng-container *ngIf="currentPanel === 'descarte-relato'">
    <app-descarte-relato
      [idObra]="idObra"
      [idRelato]="
        relatoParaDescarte?.reportID ||
        relatoParaDescarte?.id ||
        relatoParaDescarte?.raw?.reportID ||
        relatoParaDescarte?.raw?.id
      "
      [relato]="relatoParaDescarte"
      (close)="closePanel()"
      (relatoDescartado)="fecharDescarteRelato(true)"
      (loading)="onPainelLoading($event)"
    ></app-descarte-relato>
  </ng-container>
  <ng-container *ngIf="currentPanel === 'contratada'">
    <app-obra-contratada
      [idObra]="idObra"
      [moduloId]="moduloId"
      (close)="closePanel()"
      (actionConfirmed)="closePanel()"
      (loading)="onPainelLoading($event)"
    ></app-obra-contratada>
  </ng-container>
  <ng-container *ngIf="currentPanel === 'perdida'">
    <app-obra-perdida
      [idObra]="idObra"
      [moduloId]="moduloId"
      (close)="closePanel()"
      (actionConfirmed)="closePanel()"
      (loading)="onPainelLoading($event)"
    ></app-obra-perdida>
  </ng-container>

  <ng-container *ngIf="currentPanel === 'reportar-erro'">
    <app-reportar-erro
      (close)="closePanel()"
      [idObra]="idObra"
      [workName]="obraName"
      [moduleId]="moduloId"
      [module]="getModuleName(moduloId)"
      [constructorId]="constructorId"
      [constructorName]="constructorName"
      [companyId]="companyId"
      [companyName]="companyName"
      (actionConfirmed)="closePanel()"
      (loading)="onPainelLoading($event)"
    ></app-reportar-erro>
  </ng-container>
</app-side-panel>

<app-common-loader *ngIf="isLoadingObra"></app-common-loader>